import isObject from 'lodash/isObject'
import mapValues from 'lodash/mapValues'
import { Style, ThemeConfig } from '../types'

export default function applyTheme(style: Style, theme: ThemeConfig): Style {
  function mapObject(object: Record<string, any>, theme: ThemeConfig): any {
    return mapValues(object, (value, key) => {
      if (isObject(value)) return mapObject(value, theme)
      if (key.match(/color/i))
        return (
          theme.colors[value as 'primary' | 'secondary' | 'accent'] ?? value
        )
      if (key === 'fontFamily') return theme.fonts[value as 'primary'] ?? value
      return value
    })
  }

  return mapObject(style, theme)
}
